import Swiper from 'swiper';

function initDefaultSlider(slider) {
    const sliderContainer = slider;
    const sliderContainerParent = sliderContainer.parentElement;
    
    const sliderParams = {   
        speed: 600,
        nextButton: sliderContainerParent.querySelector('.theme-swiper-button-next'),
        prevButton: sliderContainerParent.querySelector('.theme-swiper-button-prev'),
        
   
    };
    if(sliderContainerParent.classList.contains('autoheight')){
        sliderParams.autoHeight = true;
    }
    
    if(sliderContainerParent.classList.contains('fade')){
        sliderParams.effect = 'fade';
    }
    

    const homeSlider = new Swiper(sliderContainer, sliderParams );
    
    
}

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.swiper-container');
    if (sliders.length) {
        for (let i = 0; i < sliders.length; i++) {
            initDefaultSlider(sliders[i]);
        }
    }
});





// WEBPACK FOOTER //
// ./assets/src/js/modules/swiper.js